import {ILoggingAPIsuccessResposnse} from "../types/loggingTypes";
import axios from "axios";

import {jsonSafeGet} from "utils/Helpers";
import {CookiesConstants} from "utils/constants";
import {parseCookies} from "utils/nookies";
import {isBrowser} from "utils/nookies/utils";
import {SSO_LOGIN_STATE} from "contexts/authSSOContext";
import {sleep} from "utils/misc/fetchClient";

export const LoggingAPICall = async (
    body: any,
): Promise<any> => {
    while (isBrowser() && !window?.[SSO_LOGIN_STATE]) {
        // sleep 5ms
        await sleep(5)
    }
    let url = `${process.env.NEXT_PUBLIC_LOGGING_URL_CLIENT}`;
    if( body.Session_id === "NA") {
        const cookies = parseCookies()
        body.Session_id = jsonSafeGet<any>(cookies[CookiesConstants.SESSION], {})?.id
    }
    return  axios.post(url , body , {
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': process.env.NEXT_PUBLIC_LOGGING_SERVER_KEY
        }
    })

};
